<template>
  <div class="p-4">
    <div class="m-title pb-3">Các trang hết hạn liên kết Salework Chat</div>
    <div class="list-page scrollbar scrollbar-hidden">
      <div v-for="(item, index) in globalData.initData.pages.filter(p=>p.expired === true)" :key="index" class="ml-3">
        <div class="d-flex align-items-center pt-2">
          <img v-if="item.picture_url" :src="item.picture_url" alt="" onerror="src='/images/default-post-image.jpg'" width="45" height="45">
          <div v-else class="picture-ava text-ava"
               :class="{'text-sp':item._id.channel=== 'Shopee', 'text-tt':item._id.channel=== 'TikTok', 'text-lz':item._id.channel=== 'Lazada'}">
            {{ item.name.charAt(0).toUpperCase() }}
          </div>
          <div class="pl-2 page-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="py-3 pl-3">Liên kết lại ngay để không bỏ lỡ tin nhắn từ khách hàng!</div>
    <div class="d-flex float-right pb-3 ">
      <div class="btn btn-secondary" @click="$emit('close')">Bỏ qua</div>
      <div class="btn btn-primary ml-1" @click="routerToConnection">Liên kết ngay</div>
    </div>

    <b-icon-x class="btn-close" scale="1.5" variant="danger" @click="$emit('close')"></b-icon-x>
  </div>
</template>

<script>
export default {
  name: "ReConnectPageModal",
  methods:{
    routerToConnection(){
      this.$router.push('/connection');
      this.$emit('close');
    }
  }
}
</script>


<style scoped>
.m-title {
  font-size: 18px;
  font-weight: 600;
  color: #CF4547;
}

.btn-close {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
}

.page-name {
  font-weight: 600;
  font-size: 14px;
}

.list-page {
  /*height: 320px;*/
  max-height: 320px;
  overflow-y: scroll;
}

.picture-ava{
  width: 40px;
  height: 40px;
  border-radius: 8px;
}

.text-ava{
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
}

.text-sp{
  color: white;
  background-color: #ef5334;
}

.text-lz{
  color: white;
  background-color: #090ab9;
}

.text-tt{
  color: white;
  background-color: black;
}


</style>